/**
 * Login-lose Lieferverzug-Ansicht fuer GlaWel.
 * Aufbau und Datenabruf liegen gemeinsam in
 * `liefertermin-shared/frontend/src/lieferverzug/ExternAnsicht.tsx` —
 * hier stehen nur die Texte dieses Lieferanten.
 */

import ExternAnsicht from '../../../liefertermin-shared/frontend/src/lieferverzug/ExternAnsicht';

export default function PublicApp() {
  return (
    <ExternAnsicht
      programmeId="glawel-liefertermin"
      titel="Liefertermine GLA-WEL"
      einleitung={
        'Auswertung der wöchentlich gemeldeten Liefertermine gegen den tatsächlichen '
        + 'Warenausgang — alle Aufträge der GLA-WEL-Terminliste. Die Zahlen aktualisieren '
        + 'sich mit jedem Import der Liste.'
      }
    />
  );
}
